<style lang="less" scoped>
    .basic-demo1-tree-wrapper{
        -webkit-box-shadow: 0 0 2px 0 purple;
        -moz-box-shadow: 0 0 2px 0 purple;
        box-shadow: 0 0 2px 0 purple;
        min-height: 100px;
        height: 200px;
        width: 200px;
        margin:0 0 10px;
        padding:0;
    }
</style>
<template>
    <div class="main-content">
        <h1>t-vue-tree</h1>
        <h3 class="title-mark"> 基础应用--====12121212 </h3>
   
    </div>
</template>
<script>
    export default {
        name: 'Test',
        data(){
            return {
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/views/home/index.vue